// @ts-strict-ignore
import { useFlippers } from "@shared/hooks/useFlippers/useFlippers";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";

const useEmersonCheckout = (): Boolean => {
  const { isEmerson } = useSharedGlobalConfig();

  const [isWLSCheckoutV2Enabled] = useFlippers("lighthouse_wholesale_checkout_v2");

  const isEEv2Checkout = isEmerson && isWLSCheckoutV2Enabled;

  return isEEv2Checkout;
};

export { useEmersonCheckout };
